import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './search-field.magic.css.js';
import script from './search-field.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-field",attrs:{"part":"search-field"}},[_c('magic-ui-form-field',_vm._b({attrs:{"search":"","no-margin":"","placeholder":_vm.placeholder || _vm.$t('search.search.placeholder'),"value":_vm.value}},'magic-ui-form-field',_vm.$filteredAttrs,false)),_vm._v(" "),(!_vm.value)?_c('magic-ui-icon',{staticClass:"icon icon--search",attrs:{"name":"search","part":"icon icon--search"}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade-in"}},[(_vm.value)?_c('button',{staticClass:"button",attrs:{"part":"button","type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onClear()}}},[_c('magic-ui-icon',{staticClass:"icon icon--remove",attrs:{"name":"close","part":"icon icon--remove"}})],1):_vm._e()])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-79f8591c_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-79f8591c";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
